import React from 'react'

//assets
import '../assets/css/PanelMonitor.css';

// 引入 ECharts 主模块
// import echarts from 'echarts/lib/echarts';
// import 'echarts'
// import 'echarts/lib/component/title'
// import 'echarts/lib/component/toolbox'

//plugin
// import { AxisLeft, AxisBottom, AxisRight, AxisTop } from '@vx/axis';
// import { appleStock } from '@vx/mock-data';
// import { AreaClosed, Bar, LinePath } from '@vx/shape';
// import { Group } from '@vx/group';
// import { scaleTime, scaleLinear } from '@vx/scale';
// import { extent, max } from 'd3-array';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import purple from '@material-ui/core/colors/purple';
import CircularProgress from '@material-ui/core/CircularProgress';
//store
import { observer } from 'mobx-react';
import widget from '../store/widget'

const width = 430;
const height = 300;

const styles = theme => ({
  colorSwitchBase: {
    color: purple[300],
    '&$colorChecked': {
      color: purple[500],
      '& + $colorBar': {
        backgroundColor: purple[500],
      },
    },
  },
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#52d869',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(80px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: 50,
    width: 110,
    height: 40,
    marginTop: -20,
    marginLeft: -20,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 50,
    height: 50,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
});

@observer
class PanelMonitor extends React.Component {

  state = {
    loading: false
  }

  componentDidMount = () => {
    if (this.props.tool === 'dataVisualization') {
      this.echarts()
    }
  }

  echarts = () => {
    const { data, type, property, panelId } = this.props
    let chartsId = panelId
    var myChart = window.echarts.init(document.getElementById(chartsId));
    var option = {
      // 内边距
      grid: {
        left: 80,
        bottom: 80,
        right: 80
      },
      toolbox: {
        feature: {
          dataZoom: {
            yAxisIndex: 'none',
          },
          restore: {},
          saveAsImage: {},
        },
      },
      tooltip: {
        renderMode: 'html',
        formatter: function (data) {
          return `<div style="text-align:left"}>${data.name}<br/>數據：${data.value} </div>`
        },

      },
      dataZoom: [
        {
          show: true,
          realtime: true,
          start: 0,
          end: 100,
          // 缩放区域的字体颜色
          textStyle: {
            color: '#fff'
          }
        },
      ],
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          axisLine: { onZero: false },
          data: data.map(str => {
            return (new Date(str.meta.timestamp * 1000)).toLocaleString('chinese', { hour12: false }).replace(' ', '\n');
          }),
          // x 轴的颜色宽度
          axisLine: {
            lineStyle: {
              color: '#fff',
              width: 1,
            }
          }
        }
      ],
      yAxis: [
        {
          splitLine: {
            // 改变描线的颜色
            lineStyle: {
              color: 'rgba(200,200,200,.3)'
            }
          },
          // y 轴的颜色宽度
          axisLine: {
            lineStyle: {
              color: '#fff',
              width: 1,
            }
          }

        },
      ],
      series: [
        {
          type: 'line',
          animation: false,
          // 是否显示区域图
          areaStyle: {
            color: type === 'area' ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0)'
          },
          // 折线样式
          itemStyle: {
            normal: {
              color: '#fff',
              lineStyle: {
                color: '#fff',
                width: 1
              }
            }
          },
          // area 填充色
          markArea: {
            silent: true,
            data: [[{
              xAxis: '2009/9/12\n7:00'
            }, {
              xAxis: '2009/9/22\n7:00'
            }]]
          },
          data: data.map(x => x[property])
        },

      ]
    };
    myChart.clear()
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
  }

  componentDidUpdate = () => {
    const { type, property, eventName, tool } = this.props
    let prent = document.getElementById(this.props.panelId) || document.getElementById(`${eventName}-${property}-${tool}-${type}`)
    if (this.props.tool === 'dataVisualization') {
      this.echarts()
      if (prent && prent.children[0].tagName === "DIV") {
        prent.children[0].style.display = 'block'
      }
    } else {
      if (prent && prent.children[0].tagName === "DIV") {
        prent.children[0].style.display = 'none'
      }
    }
  }

  componentWillReceiveProps = () => {
    // console.log('componentWillReceiveProps',this.props.tool)
    // if (this.props.tool === 'dataVisualization') {
    //   this.echarts()
    // }
  }

  handleChange = name => event => {
    widget.loading = true;
    event.target.checked
      ? widget.pushState(this.props.eventName, this.props.property, 1)
      : widget.pushState(this.props.eventName, this.props.property, 0);
    this.setState({
      loading: true
    }, () => {
      setTimeout(() => {
        this.setState({
          loading: false
        })
      }, 1500)
    })
  };
  render() {
    const { classes, panelId } = this.props;
    const { loading } = this.state

    if (this.props.tool == 'widget') {
      console.log(this.props.data.length)
      return (
        <div className='PanelMonitor__widget' id={panelId}>
          <h2 className='PanelMonitor__title'>Switch</h2>
          {(widget.loading && loading)
            ? <div>
              <CircularProgress
                className={classes.progress}
                color="secondary"
                size={26}
              />
            </div>
            : null
          }
          <div className="PanelMonitor__switch">
            <Switch
              checked={this.props.data.length > 0 && this.props.data[this.props.data.length - 1][this.props.property]}
              onChange={this.handleChange('checkedA')}
              value="checkedA"
              classes={{
                switchBase: classes.iOSSwitchBase,
                bar: classes.iOSBar,
                icon: classes.iOSIcon,
                iconChecked: classes.iOSIconChecked,
                checked: classes.iOSChecked,
              }}
            />
          </div>
          <span className='PanelMonitor__label--off'>OFF</span>
          <span className='PanelMonitor__label--on'>ON</span>
        </div>
      )
    } else {
      return (
        <div id={panelId} style={{ width: width, height: height, position: 'relative', left: -20 }}>

        </div>
      )
    }
  }
}
;
export default withStyles(styles)(PanelMonitor);



// WEBPACK FOOTER //
// ./src/components/PanelMonitor.js